<template>
  <div id="app">
    <TableView
      :headers="columns"
      :rows="items"      
      :sort="sort2"
      :pagination="pagination"
      css-style="table table-sm"      
    >
      <!-- <template v-slot:ID="{ column }">
        <table>
          <tr>
            <td><input type="radio" value="Approve" v-model="selectedAction" @click="selectAll" /> Approve</td>
            <td><input type="radio" value="Reject" v-model="selectedAction" @click="selectAllReject" /> Reject</td>
            <td><input type="radio" value="No Action" v-model="selectedAction" @click="selectAllNoAction" /> No Action</td>
          </tr>
        </table>
      </template> -->
      <template v-slot:items="{ row }">        
        <td>{{ row.first_name }}</td>
        <td>{{ row.last_name }}</td>
        <td>{{ row.email }}</td>
        <td>{{ row.age }}</td>
        <td>{{ row.country }}</td>
        <td>{{ row.category }}</td>
        <td>{{ row.last_update }}</td>
      </template>      
      <template v-slot:no-data>
        <span>No data</span>
      </template>
    </TableView>
  </div>
</template>
<script>
import { columns, rows } from './data.js'
export default {
    name: 'app',
    data() {
        return {
            loaded: true,
            selectedAction: "No Action",
            allApproveSelected: true,
            allRejectSelected: false,
            allNoActionSelected: false,
            columns: columns,
            items: rows,
            sort2:{
              field: 'Modified',
              order: 'asc'
            },      
            pagination:{
              itemsPerPage: 25,
              align: 'center',
              visualStyle: 'select'
            }
        }
    },
    computed: {
      
    },
    methods: {
      formatNumber(num) {
        if (num == "") return ""
        let formattedNum = parseFloat(num).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
        return formattedNum;
      },
      selectAll() {
          var self = this;
          self.$nextTick(function () {
              switch(self.selectedAction)
              {
                  case "Approve":
                      self.selectAllApprove();
                      break;
                  case "Reject":
                      self.selectAllReject();
                      break;
                  case "No Action":
                      self.selectAllNoAction();
                      break;
              }
          });                        
      },
      selectAllApprove(evt) {
          var self = this;
          for (var i = 0; i < self.items.length; i++)
              self.items[i].action = "Approve_" + self.items[i].ID;

          self.allApproveSelected = true;
          self.allRejectSelected = false;
          self.allNoActionSelected = false;
      },
      selectAllReject(evt) {
          var self = this;
          for (var i = 0; i < self.items.length; i++)
              self.items[i].action = "Reject_" + self.items[i].ID;

          self.allApproveSelected = false;
          self.allRejectSelected = true;
          self.allNoActionSelected = false;
      },
      selectAllNoAction(evt) {
          var self = this;
          for (var i = 0; i < self.items.length; i++)
              self.items[i].action = "NoAction_" + self.items[i].ID;
          self.allApproveSelected = false;
          self.allRejectSelected = false;
          self.allNoActionSelected = true;
      }
    }
}
</script>

<style lang="scss">
@import url(https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css);
@import url(https://cdnjs.cloudflare.com/ajax/libs/twitter-bootstrap/4.3.1/css/bootstrap.min.css);
@import url(http://fonts.googleapis.com/css?family=Roboto+Mono);
body, html{
  height: 100%;
}
#app {
  font-family: 'Roboto Mono', Helvetica, Arial, sans-serif;
  font-size: 11px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  width: 90%;
  margin: 0 auto;
}
h1{
  margin-bottom: 2em;
  color: #f90;
}
.separator{
  margin: 2em 0;
  text-align: center;
}
.custom-style {
  // Table styles
  .vcc-table {
    border-collapse: collapse;
    width: 100%;
    thead {
      th { 
        border-bottom: 1px solid #ffffff;
        padding: 0 10px;
        height: 48px;
        text-align: left; 
        font-size: 1em; 
        color: #fff;
        background-color: #7cc3fd; 
        cursor: pointer; 
        &:hover{
          span{
            text-decoration: underline;
            text-decoration-style: dotted;
          }
        }        
        i{
          color: #ffffff; 
          &.active{
            color: #ff00aa;
            + span{
              color: #a9237c;
            }
          }
        }       
      }
    }
    tbody {
      tr{
        &:nth-child(odd){
          background-color: #e9f5ff;
        }
        &:nth-child(even){
          background-color: #fafaeb;
        }
      }
      td {
        border-bottom: 1px solid #ffffff;
        padding: 0 10px;
        height: 48px;
        font-size: 1em; 
      }
    }
  }
  // Paginator styles    
  .vcc-paginator{
    margin-top: .5em;
    select{
      border: 1px solid #7cc3fd;
      border-radius: 8px;
      color: #ffffff;
      background-color:  #7cc3fd;
      outline: none;
    }
    button{
      border: 1px solid #7cc3fd;
      border-radius: 8px;
      color: #ffffff;
      background-color:  #7cc3fd;
      outline: none;
    }    
  }
}
</style>
